module.exports = __webpack_public_path__ + "assets/img/ban4.bb46a925.jpg";